import { Container } from "react-bootstrap";
import SectionTitle from "../../components/common/SectionTitle/SectionTitle";
import { useTranslation } from "react-i18next";
import "./PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <div className="privacy-policy-page">
      <Container>
        <div className="section-spacing">
          <SectionTitle
            subtitle={t("privacy.subtitle")}
            title={t("privacy.title")}
          />
        </div>

        <p className="reg-text">
          <strong>{t("privacy.lastUpdated")}</strong>
        </p>

        <p className="reg-text">{t("privacy.intro1")}</p>
        <p className="reg-text mb-4">{t("privacy.intro2")}</p>

        {/* Section 1 */}
        <h5 className="reg-title">{t("privacy.section1.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section1.content")}</p>

        {/* Section 2 */}
        <h5 className="reg-title">{t("privacy.section2.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section2.content")}</p>

        <h6 className="reg-list-title">{t("privacy.section2.personalTitle")}</h6>
        <ul className="reg-list">
          <li><p>{t("privacy.section2.personal1")}</p></li>
          <li><p>{t("privacy.section2.personal2")}</p></li>
          <li><p>{t("privacy.section2.personal3")}</p></li>
          <li><p>{t("privacy.section2.personal4")}</p></li>
        </ul>

        <h6 className="reg-list-title">{t("privacy.section2.techTitle")}</h6>
        <ul className="reg-list">
          <li><p>{t("privacy.section2.tech1")}</p></li>
          <li><p>{t("privacy.section2.tech2")}</p></li>
          <li><p>{t("privacy.section2.tech3")}</p></li>
          <li><p>{t("privacy.section2.tech4")}</p></li>
        </ul>

        {/* Section 3 */}
        <h5 className="reg-title">{t("privacy.section3.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section3.content")}</p>
        <ul className="reg-list">
          <li><p>{t("privacy.section3.item1")}</p></li>
          <li><p>{t("privacy.section3.item2")}</p></li>
          <li><p>{t("privacy.section3.item3")}</p></li>
          <li><p>{t("privacy.section3.item4")}</p></li>
        </ul>

        {/* Section 4 */}
        <h5 className="reg-title">{t("privacy.section4.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section4.content")}</p>
        <ul className="reg-list">
          <li><p>{t("privacy.section4.item1")}</p></li>
          <li><p>{t("privacy.section4.item2")}</p></li>
          <li><p>{t("privacy.section4.item3")}</p></li>
          <li><p>{t("privacy.section4.item4")}</p></li>
          <li><p>{t("privacy.section4.item5")}</p></li>
          <li><p>{t("privacy.section4.item6")}</p></li>
        </ul>

        {/* Section 5 */}
        <h5 className="reg-title">{t("privacy.section5.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section5.content")}</p>
        <ul className="reg-list">
          <li><p>{t("privacy.section5.item1")}</p></li>
          <li><p>{t("privacy.section5.item2")}</p></li>
          <li><p>{t("privacy.section5.item3")}</p></li>
          <li><p>{t("privacy.section5.item4")}</p></li>
        </ul>

        {/* Section 6 */}
        <h5 className="reg-title">{t("privacy.section6.title")}</h5>
        <p className="reg-text">{t("privacy.section6.content1")}</p>
        <p className="reg-text mb-4">{t("privacy.section6.content2")}</p>
        <ul className="reg-list">
          <li><p>{t("privacy.section6.item1")}</p></li>
          <li><p>{t("privacy.section6.item2")}</p></li>
          <li><p>{t("privacy.section6.item3")}</p></li>
        </ul>

        {/* Section 7 */}
        <h5 className="reg-title">{t("privacy.section7.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section7.content")}</p>
        <ul className="reg-list">
          <li><p>{t("privacy.section7.item1")}</p></li>
          <li><p>{t("privacy.section7.item2")}</p></li>
          <li><p>{t("privacy.section7.item3")}</p></li>
        </ul>

        {/* Section 8 */}
        <h5 className="reg-title">{t("privacy.section8.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section8.content")}</p>

        {/* Section 9 */}
        <h5 className="reg-title">{t("privacy.section9.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section9.content")}</p>

        {/* Section 10 */}
        <h5 className="reg-title">{t("privacy.section10.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section10.content")}</p>

        {/* Section 11 */}
        <h5 className="reg-title">{t("privacy.section11.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section11.content")}</p>

        {/* Section 12 */}
        <h5 className="reg-title">{t("privacy.section12.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section12.content")}</p>

        {/* Section 13 */}
        <h5 className="reg-title">{t("privacy.section13.title")}</h5>
        <p className="reg-text mb-4">{t("privacy.section13.content")}</p>
      </Container>
    </div>
  );
}